import { atom } from 'jotai';

import type { EnrollmentFilters } from '../../types/enrollment';

export const defaultEnrollmentFilters: EnrollmentFilters = {
  company: '',
  polo: '',
  email: '',
  cpf: '',
  studentName: '',
  statuses: [],
  courseId: '',
  documentationFilter: 'all',
  documentStartDate: '',
  documentEndDate: '',
};

/**
 * Filtros em edição — alterados em tempo real pelos inputs da `EnrollmentFilterBar`.
 * Não disparam busca por si só; servem apenas como rascunho até o usuário
 * confirmar com o botão "Buscar".
 */
export const enrollmentFiltersAtom = atom<EnrollmentFilters>(defaultEnrollmentFilters);

/**
 * Filtros efetivamente aplicados à query do grid. Só mudam quando o usuário
 * clica em "Buscar" (ou limpa os filtros). É esse átomo que é traduzido em
 * query params e dispara a chamada ao backend.
 */
export const enrollmentAppliedFiltersAtom = atom<EnrollmentFilters | null>(null);

/**
 * Indica se os filtros possuem ao menos um valor preenchido — usado para
 * decidir se a busca deve ser disparada.
 */
export function hasAnyEnrollmentFilter(filters: EnrollmentFilters): boolean {
  return (
    filters.company.trim() !== '' ||
    filters.polo.trim() !== '' ||
    filters.email.trim() !== '' ||
    filters.cpf.trim() !== '' ||
    filters.studentName.trim() !== '' ||
    filters.statuses.length > 0 ||
    filters.courseId.trim() !== '' ||
    filters.documentationFilter !== 'all' ||
    filters.documentStartDate.trim() !== '' ||
    filters.documentEndDate.trim() !== ''
  );
}
